import { render } from "./ContactsList.vue?vue&type=template&id=b34a2e24"
import script from "./ContactsList.vue?vue&type=script&lang=ts"
export * from "./ContactsList.vue?vue&type=script&lang=ts"
script.render = render

export default script